export const YES_NO_OPTIONS = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

// PostgreSQL stores booleans as "t"/"f" in string columns
// Use this for fields that store boolean values as text
export const YES_NO_TEXT_OPTIONS = [
  { value: "t", label: "Yes" },
  { value: "f", label: "No" },
];
